import { useLocalization } from '@ais-ui/locale-management';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import React from 'react';
import { cn } from '@ais-ui/utils';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  InfoIconTooltip,
  Separator,
} from '@ais-ui/ui-core';
import { Replay } from './Replay';
import { ReplayVideo } from './ReplayVideo';

interface ReplaysProps {
  className: string;
}

export const Replays = ({ className }: ReplaysProps) => {
  const { messages } = useLocalization();
  const onExit = useOnMapPanelExit();

  return (
    <Card className={cn('w-[560px] h-[320px]', className)}>
      <CardHeader className="flex flex-row justify-between p-0">
        <div className="flex space-x-2">
          <CardTitle className="text-lg font-medium text-muted-foreground p-6 pr-0">
            {messages.replayTitle}
          </CardTitle>
          <InfoIconTooltip>{messages.replayStartInfoIcon}</InfoIconTooltip>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="mr-2"
          onClick={() => onExit()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
            className="h-4 w-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </Button>
      </CardHeader>
      <CardContent className="space-y-4">
        <Separator className="-mt-4"></Separator>
        <ReplayVideo></ReplayVideo>
        <Separator></Separator>
        <Replay></Replay>
      </CardContent>
    </Card>
  );
};
